export const ERROR = "ERROR";
export const PENDING = "PENDING";